export enum CarrouselTypeEnum {
	DOTS = 'dots',
	ARROWS = 'arrows',
	NUMBERS = 'numbers',
	ARROWS_DOTS = 'arrows-dots',
}
